/* eslint-disable react/require-default-props,react/jsx-no-target-blank */

import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';

import { FontAwesome } from '../../../../components/FontAwesome';
import { makeMetricsLogEvent } from '../../../../../ReduxStorage/Metrics/manualEventDispatchers';

/* global _OL_ORIGIN */

export class _ProfileHeaderLocation extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    hasEditAccess: PropTypes.bool,
    metricsLogEvent: PropTypes.func.isRequired,
  };

  onLocationClick = () => {
    const { metricsLogEvent } = this.props;
    metricsLogEvent('ProfileChanged', {
      itemChanged: 'location',
    });
  };

  render() {
    const { user, hasEditAccess } = this.props;

    if (hasEditAccess) {
      return (
        <p className="location">
          <FontAwesome name="map-marker" />
          <span className="hidden-text">Location</span>{' '}
          {user.get('accessibleTimezone')}{' '}
          <span className="info-edit location-edit">
            <a
              href={`${_OL_ORIGIN}/accounts/account-settings/`}
              target="_blank"
              className="info-edit-link location-edit-link"
              onClick={this.onLocationClick}
            >
              <FontAwesome className="location-fa" name="edit" />
              <span className="hidden-text">Update your location</span>
            </a>
          </span>
        </p>
      );
    }

    return (
      <p
        className={classnames('location', {
          'skeleton-loading': !user.get('accessibleTimezone'),
        })}
      >
        <FontAwesome name="map-marker" /> {user.get('timezone')}
      </p>
    );
  }
}

export const ProfileHeaderLocation = connect(undefined, {
  metricsLogEvent: makeMetricsLogEvent,
})(_ProfileHeaderLocation);
